import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '~/lib/utils';

const defaultTextareaStyles =
  'focus:ring-input-active focus:border-input-active border-input-border bg-input rounded border px-3.5 py-2 transition-colors file:border-0 file:bg-transparent disabled:cursor-not-allowed disabled:opacity-50';

const textareaVariants = cva('border-0 bg-transparent w-full ', {
  variants: {
    variant: {
      default: defaultTextareaStyles,
      transparent: '',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

interface TextareaProps extends VariantProps<typeof textareaVariants>, TextareaHTMLAttributes<HTMLTextAreaElement> {
  className?: string;
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({ variant, className, ...props }, ref) => {
  return <textarea className={cn(textareaVariants({ variant }), className)} ref={ref} {...props} />;
});
Textarea.displayName = 'Textarea';

export { Textarea, defaultTextareaStyles, type TextareaProps };
